/**
 * 警告 icon
 */
const WarnIcon = ({ width = 12, height = 12, color = '#DA291C', ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M6 1C3.23857 1 0.999999 3.23858 1 6C1 8.76143 3.23857 11 6 11C8.76143 11 11 8.76143 11 6C11 3.23857 8.76142 1 6 1Z"
        stroke={color}
        strokeLinejoin="round"
      />
      <path
        d="M6.5 8.54688L6.5 8.04687L6 7.54687L5.5 8.04688L5.5 8.54688L6.5 8.54688Z"
        fill={color}
      />
      <path
        d="M5.5 3.48118L5.5 6.57031L6 7.07031L6.5 6.57031L6.5 3.48118L5.5 3.48118Z"
        fill={color}
      />
    </svg>
  )
}

export default WarnIcon
